import { flsModules } from "./modules.js";

import noUiSlider from "nouislider";

document.addEventListener("DOMContentLoaded", () => {
  const yearSlider = document.getElementById("year-slider");
  if (!yearSlider) return;

  const minYear = 2000;
  const maxYear = new Date().getFullYear();

  noUiSlider.create(yearSlider, {
    start: [minYear, maxYear],
    connect: true,
    range: {
      min: minYear,
      max: maxYear,
    },
    step: 1,
  });

  const inputMin = document.getElementById("year_min");
  const inputMax = document.getElementById("year_max");

  yearSlider.noUiSlider.on("update", function (values) {
    inputMin.value = Math.round(values[0]);
    inputMax.value = Math.round(values[1]);
  });
});

const mileageSlider = document.getElementById("mileage-slider");

if (mileageSlider) {
  const minMileage = 0;
  const maxMileage = 300000;

  noUiSlider.create(mileageSlider, {
    start: [minMileage, maxMileage],
    connect: true,
    step: 1000,
    range: {
      min: minMileage,
      max: maxMileage,
    },
  });

  const inputMin = document.getElementById("mileage_min");
  const inputMax = document.getElementById("mileage_max");

  mileageSlider.noUiSlider.on("update", function (values) {
    inputMin.value = Math.round(values[0]);
    inputMax.value = Math.round(values[1]);
  });
}

const priceSlider = document.getElementById("price-slider");

if (priceSlider) {
  const minPrice = 0;
  const maxPrice = 100000;

  noUiSlider.create(priceSlider, {
    start: [minPrice, maxPrice],
    connect: true,
    step: 500,
    range: {
      min: minPrice,
      max: maxPrice,
    },
  });

  const inputMin = document.getElementById("price_min");
  const inputMax = document.getElementById("price_max");

  priceSlider.noUiSlider.on("update", function (values) {
    inputMin.value = Math.round(values[0]);
    inputMax.value = Math.round(values[1]);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // VOLUME
  const volumeSlider = document.getElementById("volume-slider");

  if (volumeSlider) {
    noUiSlider.create(volumeSlider, {
      start: [
        document.getElementById("volume_min").value || 0,
        document.getElementById("volume_max").value || 6,
      ],
      connect: true,
      range: {
        min: 0,
        max: 6,
      },
      step: 0.1,
    });

    volumeSlider.noUiSlider.on("update", function (values) {
      const min = parseFloat(values[0]).toFixed(1);
      const max = parseFloat(values[1]).toFixed(1);

      document.getElementById("volume_min").value = min;
      document.getElementById("volume_max").value = max;

      document.getElementById("volume-value-min").textContent = min;
      document.getElementById("volume-value-max").textContent = max;
    });
  }

  // POWER
  const powerSlider = document.getElementById("power-slider");

  if (powerSlider) {
    noUiSlider.create(powerSlider, {
      start: [
        document.getElementById("power_min").value || 0,
        document.getElementById("power_max").value || 600,
      ],
      connect: true,
      range: {
        min: 0,
        max: 600,
      },
      step: 10,
    });

    powerSlider.noUiSlider.on("update", function (values) {
      const min = Math.round(values[0]);
      const max = Math.round(values[1]);

      document.getElementById("power_min").value = min;
      document.getElementById("power_max").value = max;

      document.getElementById("power-value-min").textContent = min;
      document.getElementById("power-value-max").textContent = max;
    });
  }
});


document.querySelectorAll('.range-slider').forEach(slider => {

    const min = parseFloat(slider.dataset.min);
    const max = parseFloat(slider.dataset.max);
    const step = parseFloat(slider.dataset.step);

    const inputMin = document.getElementById(slider.dataset.inputMin);
    const inputMax = document.getElementById(slider.dataset.inputMax);

    const startMin = parseFloat(inputMin.value || min);
    const startMax = parseFloat(inputMax.value || max);

    noUiSlider.create(slider, {
        start: [startMin, startMax],
        connect: true,
        step: step,
        range: {
            min: min,
            max: max
        }
    });

    slider.noUiSlider.on('update', (values) => {
        inputMin.value = parseFloat(values[0]).toFixed(step < 1 ? 1 : 0);
        inputMax.value = parseFloat(values[1]).toFixed(step < 1 ? 1 : 0);
    });

    inputMin.addEventListener('change', () => {
        slider.noUiSlider.set([inputMin.value, null]);
    });

    inputMax.addEventListener('change', () => {
        slider.noUiSlider.set([null, inputMax.value]);
    });

});

// console.log("Range");
